// Whether this page's session has ended (logout, here or in another tab). Once it has, nothing from
// it may be written to the device or sent: persisted store state, IndexedDB records, mapping drafts
// and the results of requests still on their way all check this. It is never unset -- ending a
// session finishes with a fresh page (helpers/session.js) -- so the module holds no imports and can
// be read from anywhere.
let ended = false

export function sessionEnded() {
  return ended
}

export function markSessionEnded() {
  ended = true
}

// Store state persisted with pinia-plugin-persistedstate goes through this, so a store changed after
// the session ended (a request answering late, a store being reset) cannot write its old data back
// after logout has cleared it.
export const persistedStateStorage = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => {
    if (!ended) localStorage.setItem(key, value)
  }
}
